module.exports = __webpack_public_path__ + "static/12-4199025e44bd2feda598448cd3ff7f79.wav";